import { StateCreator } from "zustand"
import { mergeDeep } from "../services/functionsGerais"
import { StoreType } from "./AppStore"

type RecursivePartial<T> = {
    [P in keyof T]?: T[P] extends (infer U)[]
        ? RecursivePartial<U>[]
        : T[P] extends object | undefined
        ? RecursivePartial<T[P]>
        : T[P]
}

export type ConfigsType = {
    printer: {
        tamanhoFonteImpressao: number
        tamanhoFonte: number
        agruparViasImpressao: number
        tipoImpressao: string
        impressoras: Array<string>
        imprimirLogo?: boolean
        negrito?: boolean
        imprimir99automatico?: boolean
        tamanhoFonteSelect?: string
        imprimirComandaCompleta?: boolean
        impressoraComandaCompleta?: string
        imprimirComandasIfood?: boolean
    }
    recebedor: {
        exibicaoMaxima: number
        aceitarPedidoAutomatico: boolean
        prepararPedidoAutomatico?: boolean
        imprimir: boolean
        buscarAutomaticamenteXSegundos: number
        efeitoSonoro: boolean
        exibirTempoEspera: boolean
        limitePedidosFinalizados?: number
        imprimirPedidoAutomatico?: boolean
        duracaoEfeitoSonoro?: string
        mostrarEndereco?: boolean
    }
    cardapio: {
        sincronizarCardapio99Automaticamente: boolean
    }
    user?: {
        id: number
        perfil: string
        usuario: string
        parametros: {
            id: number
            estabelecimento: {
                id: number
                nome: string
                endereco: string
                bairro: string
                telefone: string
                tempoEntregaTexto: string
                tempoRetiradaLocal: string
                categoria: string
                tipoCardapio: number
                tempoEntrega: number
                possuiEntrega: boolean
                possuiDelivery: boolean
                possuiEnderecoAtendido: boolean
                apenasRetiradaNoLocal: boolean
                online: boolean
                pausado: boolean
                naoAtendido: boolean
                permiteRetiradaBalcao: boolean
                urlLogo: string
                urlSite: string
                versao: number
                whatsappgrupo: string
                whatsapp: boolean
                bannerEstrategia: boolean
                google: boolean
                panfletos: boolean
                instagram: boolean
                latitude: number
                longitude: number
                precoMedio: number
                possuiPedidoMesa: boolean
                opcoesEntrega: Array<string>
                situacao: number
                solicitarComanda: boolean
                somarQtdItens: boolean
                fazerZoomExibicaoFoto: boolean
                adicionarItensNaTelaInicial: boolean
                permiteFormaPagamentoMesa: boolean
                visivel: boolean
                permitirDesconectarMesa: boolean
                manterEnderecoCliente: boolean
            }
            aceitarPedidoAutomatico: boolean
            impressaoQz: boolean
            impressaoAlternada: boolean
            novaTela: boolean
            viasImpressao: number
            modoIzza: number
            deliveryAtivo: boolean
            tempoRetiradaLocal: string
            valorMinimoPedido: number
            valorMinimoRetiradaNoLocal: number
            minimoEntregaGratis: number
            tempoEntregaTexto: string
            fusoHorario: number
            entregaGratis: boolean
            minimoSelosGerar: number
            maximoSelosGerar: number
            quantideMaximaMensal: number
            bonificarIndicacaoAmigos: boolean
            bonificarPesquisaSatisfacao: boolean
            vencimentoMensal: boolean
            corPrimaria: string
            corSecundaria: string
            appNome: string
            situacaoPagamento: string
            maximoRegistroSelosVirtuaisDiarios: number
            maximoRegistroSelosImpressosDiarios: number
            enderecoRetiradaFuiDelivery: string
            ativarFuiDelivery: boolean
            ativarIndiana: boolean
            ativarMvarandas: boolean
            ativaEcletica: boolean
            idPartnerSaipos: string
            codStoreSaipos: string
            ativaSaipos: boolean
            clientIdGetnet: string
            secretIdGetnet: string
            sellerIdGetnet: string
            ativaGetnet: boolean
            pontuarNoDelivery: boolean
            pontuarNoResgate: boolean
            resgatarAutomaticoNoDelivery: boolean
            registrarValorConsumo: boolean
            exibirProdutoPremio: boolean
            valorMinimoParaUsarCupomDesconto: number
            alertarOffline: boolean
            exigirConfirmacaoPedido: boolean
            separadorQuantidadeImpressao: string
            imprimirQuantidadeUm: boolean
            imprimirQuantidadeUmOpcoes: boolean
            imprimirCep: boolean
            possuiModuloPedidosMesa: boolean
            imprimirCidade: boolean
            imprimirClienteNovo: boolean
            imprimirCpf: boolean
            imprimirTotalPorProduto: boolean
            imprimirCategoria: boolean
            imprimirRodape: boolean
            imprimirDataNascimento: boolean
            imprimirQtdPedidos: boolean
            imprimirDescricaoProdutoPedido: boolean
            imprimirDescricaoItemPedido: boolean
            imprimirValorOpcionais: boolean
            imprimirFormaPagamentoTopo: boolean
            imprimirItemAgrupado: boolean
            imprimirLinhaPorProduto: boolean
            imprimirSubTotal: boolean
            imprimirEntregador: boolean
            registroMultiplo: boolean
            validarMaximoDiarioDelivery: boolean
            considerarTaxaEntregaCalculoSelos: boolean
            considerarTaxaEntregaPedidoMinimo: boolean
            tipoImpressao: number
            appPrincipal: string
            apenasRetiradaNoLocal: boolean
            pontuarPorProduto: boolean
            categorizarClientes: boolean
            exigirCpfParaDesconto: boolean
            exigirFacebookEndUnicoParaDesconto: boolean
            exigirEnderecoUnicoParaDesconto: boolean
            seloDuploAtivado: boolean
            permiteMinimoEntregaPorBairro: boolean
            permiteTaxaEntregaNoturna: boolean
            horaInicioTurnoNoite: number
            horaInicioTurnoDia: number
            fatorMultiplicadorSelos: number
            permiteResgatarCartelaIncompleta: boolean
            exibirAdicionaisCadastroCardapio: boolean
            exibirConfiguracaoAvancadaProduto: boolean
            reduzirTamanhoFotoCardapio: boolean
            comissaoPagamentoOnline: number
            qntTotalMensagensWhatsApp: number
            exigirValidacaoTelefonePagamentoOnline: boolean
            permitirPagamentoOnlineRetirada: boolean
            colunasPorLinhaImpressao: number
            agruparViasImpressao: boolean
            ativarClearSale: boolean
            bloquearPagamentoOnlinePrimeiraCompra: boolean
            ignorarPedioMinimoNoResgate: boolean
            tocarNovoPedidoSite: boolean
            urlSiteAplicativo: string
            calculoEntrega: number
            solicitarComanda: boolean
            somarQtdItens: boolean
            fazerZoomExibicaoFoto: boolean
            adicionarItensNaTelaInicial: boolean
            permiteFormaPagamentoMesa: boolean
            exibirRegistroPedidos: boolean
            possuiModuloEntregadores: boolean
            possuiIntegracaoUber: boolean
            idCardapio: number
            mostrarTelefoneSite: boolean
            ativaIntegracaoIfood: boolean
            hashInternaClienteFielIfood: boolean
            listaMotivoCancelamento: Array<{
                cod: string
                description: string
            }>
            tipoEntregaBairro: number
            assinaturaLimitada: boolean
            telaOtimizadaCardapio: boolean
            grupoOpcaoCondicional: boolean
            verificarCardapioAoFinalizarPedido: boolean
            permitirEntregadorAtualizarStatusPedido: boolean
            enviarMensagemDeAvaliacaoPedidoPelaIzza: boolean
            limitarQuantidadeItensCentral: boolean
            atualizarEtapaAoAssociarEntregador: boolean
            imprimirSemAcento: boolean
            imprimirEmNovaAba: boolean
            formatacaoImpressao: string
            tamanhoFonte: number
            larguraFonte: number
            validarEnderecoListaBloqueio: boolean
            espacoInicioLinha: boolean
            imprimirValorDoProduto: boolean
            buscaPedidosOtimizada: boolean
            impedirApenasBebidasPagamentoOnline: boolean
            percentualMaximoBebidasPagamentoOnline: number
            tipoPedidoMesa: number
            permitirEventoAckSemAceitarPedido: boolean
            enviarMensagemWhatsappFiliais: boolean
            permitirApenasPagamentoOnline: boolean
            permitirBuscaPorAdicionais: boolean
            ativaIntegracaoIfoodV2: boolean
            ativarPlugNotas: boolean
            manterEnderecoCliente: boolean
            taxaEntregaVisivelComanda: boolean
            imprimirDescricaoAdicionais: boolean
            tokenMapBox: string
            tokenGoogleMaps: string
            ecomanda: boolean
        }
    }
}

export type ConfigsStoreType = {
    configuracoes: ConfigsType | undefined
    atualizarConfiguracoes: (newConfigs: ConfigsType) => void
}

const configsAntigas = localStorage.getItem("configs")
const parsedConfigsAntigas = configsAntigas ? JSON.parse(configsAntigas) : null

const configsPadrao: RecursivePartial<ConfigsType> = {
    printer: {
        tamanhoFonteImpressao: 14,
        tamanhoFonte: 100,
        agruparViasImpressao: 1,
        tipoImpressao: "",
        // impressoras: [],
    },
    recebedor: {
        exibicaoMaxima: 200,
        imprimir: true,
        buscarAutomaticamenteXSegundos: 180,
        efeitoSonoro: true,
        exibirTempoEspera: true,
    },
    cardapio: {
        sincronizarCardapio99Automaticamente: false,
    },
}

const createConfigsStore: StateCreator<StoreType, [], [], ConfigsStoreType> = (set, get) => {
    // TODO: Remover quando estiver 100% no ar
    // localStorage.removeItem("configs")

    return {
        configuracoes: parsedConfigsAntigas
            ? mergeDeep(configsPadrao, parsedConfigsAntigas)
            : configsPadrao,
        // TODO: Testar
        atualizarConfiguracoes: (newConfigs: Partial<ConfigsType>) => {
            set(prev => ({
                configuracoes: prev.configuracoes
                    ? { ...mergeDeep(prev.configuracoes, newConfigs) }
                    : newConfigs,
            }))

            if (newConfigs.recebedor?.prepararPedidoAutomatico)
                get().prepararPedidosAutomaticos(
                    get().pedidosAceitos.concat(get().pedidosAguardandoAceitacao)
                )
            else if (newConfigs.recebedor?.aceitarPedidoAutomatico)
                get().aceitarPedidosAutomaticos(get().pedidosAguardandoAceitacao)
        },
    }
}

export default createConfigsStore
